/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Bio_SdInputs */

const en_resume_bio_sd = /** @type {(inputs: Resume_Bio_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software Developer building reliable, maintainable software solutions with a focus on quality and performance.`)
};

const ar_resume_bio_sd = /** @type {(inputs: Resume_Bio_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطور برمجيات يبني حلولًا برمجية موثوقة وسهلة الصيانة مع تركيز على الجودة والأداء.`)
};

const bn_resume_bio_sd = /** @type {(inputs: Resume_Bio_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সফটওয়্যার ডেভেলপার হিসেবে মান ও পারফরম্যান্সে নজর রেখে নির্ভরযোগ্য, টেকসই সফটওয়্যার তৈরি করি।`)
};

const de_resume_bio_sd = /** @type {(inputs: Resume_Bio_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softwareentwickler, der zuverlässige, wartbare Softwarelösungen mit Fokus auf Qualität und Leistung erstellt.`)
};

const es_resume_bio_sd = /** @type {(inputs: Resume_Bio_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador de software que crea soluciones de software confiables y fáciles de mantener con un enfoque en la calidad y el rendimiento.`)
};

const fr_resume_bio_sd = /** @type {(inputs: Resume_Bio_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur de logiciels créant des solutions logicielles fiables et maintenables en mettant l'accent sur la qualité et les performances.`)
};

const pt_resume_bio_sd = /** @type {(inputs: Resume_Bio_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor de software criando soluções de software confiáveis ​​e de fácil manutenção com foco em qualidade e desempenho.`)
};

const zh_resume_bio_sd = /** @type {(inputs: Resume_Bio_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`软件开发人员构建可靠、可维护的软件解决方案，重点关注质量和性能。`)
};

const tr_resume_bio_sd = /** @type {(inputs: Resume_Bio_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazılım Geliştiricisi, kalite ve performansa odaklanarak güvenilir, bakımı yapılabilir yazılım çözümleri oluşturur.`)
};

const ru_resume_bio_sd = /** @type {(inputs: Resume_Bio_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик программного обеспечения, создающий надежные и удобные в обслуживании программные решения, уделяя особое внимание качеству и производительности.`)
};

const pl_resume_bio_sd = /** @type {(inputs: Resume_Bio_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programista tworzący niezawodne, łatwe w utrzymaniu rozwiązania programowe, skupiający się na jakości i wydajności.`)
};

/**
* | output |
* | --- |
* | "Software Developer building reliable, maintainable software solutions with a focus on quality and performance." |
*
* @param {Resume_Bio_SdInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_bio_sd = /** @type {((inputs?: Resume_Bio_SdInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Bio_SdInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_bio_sd(inputs)
	if (locale === "bn") return bn_resume_bio_sd(inputs)
	if (locale === "de") return de_resume_bio_sd(inputs)
	if (locale === "es") return es_resume_bio_sd(inputs)
	if (locale === "fr") return fr_resume_bio_sd(inputs)
	if (locale === "pt") return pt_resume_bio_sd(inputs)
	if (locale === "zh") return zh_resume_bio_sd(inputs)
	if (locale === "tr") return tr_resume_bio_sd(inputs)
	if (locale === "ru") return ru_resume_bio_sd(inputs)
	if (locale === "pl") return pl_resume_bio_sd(inputs)
	return en_resume_bio_sd(inputs)
});